import React from "react";
import { Fade } from "react-awesome-reveal";
import profile from "../../assets/images/profileImage.jpg";

const AboutMain = () => {
    return (
        <div>
            <div className="about-main">
                <div className="about-main-left">
                    <div className="about-main-left-top">
                        <Fade direction="up" damping={0.2} duration="400" cascade>
                            <p>
                                Hello! I’m Jay, an AI engineer who enjoys building systems that
                                actually run in production.
                            </p>
                            <p>
                                My work sits at the intersection of generative AI, system
                                design, and real-world constraints—where reliability matters as
                                much as intelligence.
                            </p>
                            <p>
                                Over the years, I’ve worked on end-to-end AI platforms,
                                designing how models are orchestrated, how prompts are
                                structured, how memory and knowledge are managed, and how these
                                systems behave reliably at scale. I focus less on
                                experimentation for its own sake and more on building AI systems
                                that teams can trust and maintain.
                            </p>
                            <p>
                                Currently, I’m designing AI features for healthcare simulation
                                products, where correctness, robustness, and long-term
                                maintainability are critical. My day-to-day work involves
                                translating complex requirements into clean architectures that
                                balance performance, safety, and usability.
                            </p>
                            <p>
                                Here are a few technologies/frameworks I’ve been working with recently:
                            </p>
                        </Fade>
                    </div>
                    <Fade direction="up" damping={0.2} duration="400" cascade>
                        <div className="about-main-left-buttom">
                            <ul>
                                <li>Python</li>
                                <li>FastAPI</li>
                                <li>Prompt Engineering</li>
                                <li>Langchain</li>
                                <li>Agno</li>
                                <li>Flask</li>
                                <li>Django</li>
                                <li>PostgresSQL</li>
                                <li>Docker</li>
                            </ul>
                        </div>
                    </Fade>
                </div>
                <div className="about-main-right">
                    <Fade>
                        <div className="about-image-cover">
                            <img className="about-main-right-image" src={profile} alt="" />
                        </div>
                    </Fade>
                </div>
            </div>
        </div>
    );
};

export default AboutMain;
